import { Dispatch, GetBaseState } from '@lumapps/redux/types';
import { saveCurrentUserSettings } from '@lumapps/user/api';
import { connectedUserSelector } from '@lumapps/user/ducks/selectors';
import { actions } from '@lumapps/user/ducks/slice';

export const saveUserCookiesPreferences = (choice: boolean) => async (dispatch: Dispatch, getState: GetBaseState) => {
    try {
        const state = getState();
        await saveCurrentUserSettings(
            {
                settings: {
                    hasAcceptedCookies: choice,
                },
            },
            connectedUserSelector(state),
        );
        dispatch(actions.acceptCookies(choice.toString()));
        if (!choice) {
            window.location.reload();
        }
    } catch (e) {
        // errors silently
    }
};
